import { Transition } from "@uirouter/core";
import { UAutoToolbarController } from "../uAutoToolbar.controller";

export class UAutoJournalToolbarController extends UAutoToolbarController {
    constructor(
        $injector: angular.auto.IInjectorService,
        $transition: Transition,
    ) {
        super($injector, $transition, {
            viewType: "journal",
        });
    }
}
